package one.healthium.insights.domain.content

import kotlinx.coroutines.flow.Flow
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.models.MealPlanResultModel
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.domain.models.SavedContentOptions

interface ContentRepository {
    fun getContent(options: ContentOptions, force: Boolean = false): Flow<ContentScreenModel>
    fun getFavoriteContent(): Flow<List<SavedContentModel>>
    suspend fun addContentToFavorite(options: SavedContentOptions)
    suspend fun removeContentFromFavorite(id: String)
    fun getRecentlyContent(): Flow<List<SavedContentModel>>
    fun getPersonalMealPlan(force: Boolean = false): Flow<MealPlanResultModel>
}